module.exports = __webpack_public_path__ + "media/img/frontend_application/free_trial/calendar_icon-515bddd750f1708363c320caf5c93637.png";